import { array, literal, number, object, string, union, z } from 'zod';

export const filterColors = new Map([
  ['white', '#FFFFFF'],
  ['yellow', '#FFE600'],
  ['orange', '#FF9900'],
  ['red', '#FF0000'],
  ['pink', '#FF00F5'],
  ['purple', '#8F00FF'],
  ['blue', '#0085FF'],
  ['green', '#00CC52'],
  ['beige', '#C7BEB3'],
  ['brown', '#804500'],
  ['grey', '#808080'],
  ['black', '#000000'],
]);

const order = [...filterColors.keys()];

const searchNameToFilterName = new Map([
  ['producer', 'producer'],
  ['collection', 'collection'],
  ['color', 'color'],
  ['productGroup', 'SEARCH_CRITERIA_20'],
  ['colorIntense', 'SEARCH_CRITERIA_39'],
  ['design', 'SEARCH_CRITERIA_36'],
  ['material', 'SEARCH_CRITERIA_37'],
  ['rangeOfUse', 'SEARCH_CRITERIA_38'],
]);

const genericFilterOptionFactory = (searchName: string) =>
  object({
    showName: string(),
    selectionFilter: union([literal('s'), literal('m')]),
    filterType: union([literal('s'), literal('a')]),
    items: array(
      object({ intName: string(), showName: string(), cnt: number() }),
    ),
  }).transform((data) => ({
    // TODO: Remove mapping when Backend provides correct searchName
    searchName: searchNameToFilterName.get(searchName)!,
    selectionFilter:
      data.selectionFilter === 'm' ? ('multi' as const) : ('single' as const),
    filterType:
      data.filterType === 'a' ? ('additional' as const) : ('standard' as const),
    displayName: data.showName,
    items: data.items.map(({ intName, cnt, showName }) => ({
      intName,
      // TODO: Remove mapping when Backend provides correct searchName
      searchName: searchNameToFilterName.get(searchName)!,
      amount: cnt,
      displayName: showName,
      payload: undefined as undefined | string,
    })),
  }));

export const FilterOptionsSchema = object({
  producer: genericFilterOptionFactory('producer').optional(),
  productGroup: genericFilterOptionFactory('productGroup').optional(),
  collection: genericFilterOptionFactory('collection').optional(),
  color: genericFilterOptionFactory('color')
    .transform((data) => ({
      ...data,
      items: data.items
        .sort((a, b) => order.indexOf(a.intName) - order.indexOf(b.intName))
        .map((item) => ({ ...item, payload: filterColors.get(item.intName) })),
    }))
    .optional(),
  colorIntense: genericFilterOptionFactory('colorIntense').optional(),
  design: genericFilterOptionFactory('design').optional(),
  material: genericFilterOptionFactory('material').optional(),
  rangeOfUse: genericFilterOptionFactory('rangeOfUse').optional(),
});

export type GenericFilter = z.infer<
  ReturnType<typeof genericFilterOptionFactory>
>;

export type FilterOption = {
  payload: string | undefined;
  searchName: string;
  intName: string;
  displayName: string;
  amount: number;
}[];
